<div class="page-header">Please use Google Chrome</div>

<div>
  <div class="page-text">
    We don’t mean to be a party-pooper but we currently only support Google Chrome browser. Please
    switch to Google Chrome, or if you don’t have it, you can download it below.
  </div>
</div>

<div>
  <a
    mat-raised-button
    color="primary"
    [style.filter]="environmentSite === 'community' ? (colorAnimation.hueRotate$ | async) : null"
    href="https://www.google.com/chrome/browser/"
    target="_blank"
    class="action-button"
  >
    Get Chrome
  </a>
</div>
